////////////////////////////////////////////////////////////////////////////////////
// dateUtil.js
////////////////////////////////////////////////////////////////////////////////////

// 日付文字列をYYYY/MM/dd hh:mm形式にフォーマットする
export function formatDateTime(dateString, type = '/') {
  if (!dateString) return ''
  const date = new Date(dateString)

  // 基本のオプション設定
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }

  // 日付のフォーマット処理
  let formattedDate = date.toLocaleString('ja-JP', options)

  // 区切り文字の置換
  switch (type) {
    case '-':
      // ロケールフォーマットから「/」を「-」に置換
      formattedDate = formattedDate.replace(/\//g, '-')
      break
    case '/':
    default:
      // デフォルトは「/」なのでそのまま
      break
  }

  return formattedDate
}

// 日付文字列をYYYY/MM/dd形式にフォーマットする
export function formatDate(dateString, type = '/') {
  if (!dateString) return ''
  const date = new Date(dateString)

  // 基本のオプション設定
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }

  // 日付のフォーマット処理
  let formattedDate = date.toLocaleString('ja-JP', options)

  // 区切り文字の置換
  switch (type) {
    case '-':
      // ロケールフォーマットから「/」を「-」に置換
      formattedDate = formattedDate.replace(/\//g, '-')
      break
    case '/':
    default:
      // デフォルトは「/」なのでそのまま
      break
  }

  return formattedDate
}

// UnixタイムスタンプをYYYY/MM/dd hh:mm形式にフォーマットする
export function formatTimestamp(timestamp) {
  if (!timestamp) return ''
  return new Date(timestamp * 1000).toLocaleString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

// 現在の日本時間をISO形式で取得（タイムゾーン情報付き）
export function getCurrentJSTIsoString() {
  const now = new Date()

  // 日本時間のオフセット（UTC+9）
  const jstOffset = 9 * 60 * 60 * 1000

  // UTC時間に9時間を加算して日本時間を作成
  const jstTime = new Date(now.getTime() + jstOffset)

  // ISO文字列にしてZを+09:00に置換
  return jstTime.toISOString().replace('Z', '+09:00')
}

// 現在の日本時間を文字列で取得（YYYY/MM/dd hh:mm形式）
export function getCurrentJSTString(type = '/') {
  const now = new Date()
  return formatDateTime(now.toISOString(), type)
}

// 日付文字列を日本語形式にフォーマットする（例: 2025年8月4日）
export function formatDateJapanese(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)

  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  return `${year}年${month}月${day}日`
}

// 日付時刻文字列を日本語形式にフォーマットする（例: 2025年8月4日 23:59）
export function formatDateTimeJapanese(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)

  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes().toString().padStart(2, '0')

  return `${year}年${month}月${day}日 ${hour}:${minute}`
}

// 日付文字列をdatetime-local入力フィールド用のYYYY-MM-DDTHH:MM形式にフォーマットする
// 助成金のformatDate関数と同様にtoLocaleStringを使用
export function formatDateTimeLocal(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)

  // 日本時間として表示するため、toLocaleStringを使用
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')

  return `${year}-${month}-${day}T${hours}:${minutes}`
}

// 指定した日付の次の月の最後の日を取得する
export function getNextMonthLastDay(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)

  // 次の月の1日を取得
  const nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1)

  // 次の月の最後の日を取得（次の次の月の0日目）
  const lastDay = new Date(nextMonth.getFullYear(), nextMonth.getMonth() + 1, 0)

  return lastDay.toISOString()
}

// 日付をyyyy-mm-dd形式でフォーマットする
export function formatDateISO(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}
